"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const config_1 = __importDefault(require("@mapmaker/config"));
/**
 * Displays an image, but falls back to the property provided as 'fallback' if it is not found.
 *  If fallback is not included - Default "Image not Found" image.
 *  If fallback is a string - It is treated as the source for the fallback image.
 *  Otherwise - Fallback is rendered as an element.
 */
function SafeImage(_a) {
    var { fallback = `${config_1.default.staticUrl}/images/fallback/image-not-found.svg` } = _a, imgProps = __rest(_a, ["fallback"]);
    const [error, setError] = (0, react_1.useState)(false);
    const onError = (0, react_1.useCallback)(() => {
        setError(true);
    }, [setError]);
    if (error || !imgProps.src) {
        if (typeof fallback === "string") {
            return ((0, jsx_runtime_1.jsx)("img", Object.assign({}, imgProps, { style: Object.assign(Object.assign({}, imgProps.style), { objectFit: "contain" }), src: fallback })));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: fallback });
        }
    }
    else {
        return (0, jsx_runtime_1.jsx)("img", Object.assign({ onError: onError }, imgProps));
    }
}
exports.default = SafeImage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2FmZUltYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2hhcmVkL2ltYWdlcy9TYWZlSW1hZ2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsaUNBTWU7QUFDZiw4REFBOEM7QUFTOUM7Ozs7O0dBS0c7QUFDSCxTQUF3QixTQUFTLENBQUMsRUFHakI7UUFIaUIsRUFDaEMsUUFBUSxHQUFHLEdBQUcsZ0JBQWMsQ0FBQyxTQUFTLHNDQUFzQyxPQUU3RCxFQURaLFFBQVEsY0FGcUIsWUFHakMsQ0FEWTtJQUVYLE1BQU0sQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLEdBQUcsSUFBQSxnQkFBUSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzFDLE1BQU0sT0FBTyxHQUFHLElBQUEsbUJBQVcsRUFBQyxHQUFHLEVBQUU7UUFDL0IsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2pCLENBQUMsRUFBRSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUM7SUFFZixJQUFJLEtBQUssSUFBSSxDQUFDLFFBQVEsQ0FBQyxHQUFHLEVBQUU7UUFDMUIsSUFBSSxPQUFPLFFBQVEsS0FBSyxRQUFRLEVBQUU7WUFDaEMsT0FBTyxDQUNMLGdEQUNNLFFBQVEsSUFDWixLQUFLLGtDQUFPLFFBQVEsQ0FBQyxLQUFLLEtBQUUsU0FBUyxFQUFFLFNBQVMsS0FDaEQsR0FBRyxFQUFFLFFBQVEsSUFDYixDQUNILENBQUM7U0FDSDthQUFNO1lBQ0wsT0FBTywyREFBRyxRQUFRLEdBQUksQ0FBQztTQUN4QjtLQUNGO1NBQU07UUFDTCxPQUFPLDhDQUFLLE9BQU8sRUFBRSxPQUFPLElBQU0sUUFBUSxFQUFJLENBQUM7S0FDaEQ7QUFDSCxDQUFDO0FBeEJELDRCQXdCQyJ9